import React from 'react';
import styled from 'styled-components';

import { colors } from '../../../utils/utils';

import Icon from '../../common/Icon';

const LogoWrapper = styled.div<{ $enabled: boolean }>`
    cursor: ${props => (props.$enabled ? 'pointer' : 'default')};
    touch-action: ${props => (props.$enabled ? 'auto' : 'none')};
    pointer-events: ${props => (props.$enabled ? 'auto' : 'none')};

    user-select: none;
`;

function LogoIcon(props: { enabled?: boolean }) {
    return (
        <LogoWrapper $enabled={Boolean(props.enabled)}>
            <Icon name="I2XLogo" color={colors.blue.i2x} size={24} />
        </LogoWrapper>
    );
}

export default LogoIcon;
